import React from 'react';

const build = (image) => ({
  srcSet: image.widths.map((w) => `/img/${image.name}-${w}.webp ${w}w`).join(', '),
  src: `/img/${image.name}-${image.widths[Math.min(1, image.widths.length - 1)]}.webp`,
  width: image.widths[image.widths.length - 1],
  height: image.ratio ? Math.round((image.widths[image.widths.length - 1] * image.ratio[1]) / image.ratio[0]) : undefined,
});

// Responsive <img>: srcset + sizes, explicit dimensions (no layout shift), lazy by default.
export const Img = ({ image, alt, sizes = '100vw', priority = false, className, style }) => {
  const { srcSet, src, width, height } = build(image);
  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      width={width}
      height={height}
      alt={alt}
      className={className}
      style={style}
      loading={priority ? 'eager' : 'lazy'}
      fetchpriority={priority ? 'high' : undefined}
      decoding={priority ? 'sync' : 'async'}
    />
  );
};

// Full-bleed decorative background image for a positioned parent.
export const BgImage = ({ image, position = 'center', priority = false }) => (
  <Img
    image={image}
    alt=""
    sizes="100vw"
    priority={priority}
    className="bg-img"
    style={{ objectPosition: position }}
  />
);

export default Img;
